import React from "react";
import { Link } from "react-router-dom";

import PageBanner from "./../layouts/PageBanner";

//images
import bgImage from "./../assets/images/banner/bnr1.jpg";
import pic1 from "./../assets/images/main-slider/slider2/pic1.png";
import about from "./../assets/images/about/custom_pic1.png";
import signature from "./../assets/images/about/signature.png";
import bg4 from "./../assets/images/background/bg4.jpg";

//import shape1 from './../assets/images/pattern/shape1.png';
//import shape2 from './../assets/images/pattern/shape2.png';
//import shape3 from './../assets/images/pattern/shape3.png';
//import shape5 from './../assets/images/pattern/shape5.png';
//import shape6 from './../assets/images/pattern/shape6.png';
import NewsSlider from "../components/Home/NewsSlider";
import UpdateBlog from "../components/Home/UpdateBlog";
import OurMission from "../components/OurMission";
import { IMAGES } from "../constant/theme";

const iconBlog = [
  {
    title: "Vision",
    subheading:
      "To be the first platform that provides a supportive and encouraging environment for student entrepreneurs in Saudi Arabia’s schools",
  },
  {
    title: "Mission",
    subheading:
      "Our mission is to foster a dynamic entrepreneurial ecosystem for school students by providing the foundational support needed to launch and contribute to new business ideas",
  },
];

const wrapperBlog = [
  {
    icon: "flaticon-vr-glasses",
    title: "Educate",
    content:
      "Introduce students to the principles of crowdfunding, entrepreneurship, and supporting local startups in general",
  },

  {
    icon: "flaticon-transformation",

    title: "Empower",
    content:
      "Build confidence among young entrepreneurs by simulating real-world scenarios and providing various types of support. Inspiring future leaders and innovators",
  },
  {
    icon: "flaticon-doctor-bag",

    title: "Enable",
    content:
      "Provide a structured platform where students can pitch their ideas and receive meaningful support",
  },
  {
    icon: "flaticon-open-book",
    title: "Engage",
    content:
      "Foster a sense of collaboration and community by connecting students, mentors, and supporters, encouraging active participation and shared growth",
  },
];

const AboutUs = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner
          maintitle="Home"
          pagetitle="About Us"
          background={bgImage}
        />
        <section className="content-inner section-wrapper5">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="section-head">
                  <h5 className="sub-title">Who We Are</h5>
                  {/* <h2>Experienced more than 25 Years in Crowdfunding</h2> */}
                  <p className="m-t20" style={{ fontSize: "20px" }}>
                    Kaf is a Student-Centered Crowdfunding website that connects
                    student entrepreneurs with support from the school
                    community, aiming to encourage innovation and
                    entrepreneurship in Saudi youth
                  </p>
                </div>
                {iconBlog.map((data, index) => (
                  <div
                    className="icon-bx-wraper box-hover style-2 m-b30"
                    style={{ minHeight: "250px" }}
                    key={index}
                  >
                    <div className="icon-lg">
                      <Link to={"/services-details"} className="icon-cell">
                        <i className="flaticon-shield"></i>
                      </Link>
                    </div>
                    <div className="icon-content">
                      <h5 className="dz-tilte m-b5 text-capitalize">
                        {data.title}
                      </h5>
                      <p>{data.subheading}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="col-lg-5 m-b30">
                <div className="dz-media">
                  <img src={pic1} alt="image" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="content-inner-2 overlay-primary-dark about-wrapper2 bg-img-fix"
          style={{
            backgroundImage: "url(" + bg4 + ")",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="container">
            <div className="about-bx2">
              <div className="row g-0">
                <div className="col-lg-4">
                  <div className="dz-media">
                    <img src={about} alt="image" />
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="dz-info">
                    <h2 className="title m-b30 m-md-b20">
                      Great ideas flourish in supportive communities
                    </h2>
                    {/* <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p> */}
                    <div className="signature">
                      {/* <img src={signature} alt="image" /> */}
                      <p className="text-dark m-t15 mb-0">Jana Albeshri</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="content-inner">
          <div className="container">
            <div className="section-head text-center">
              {/* <h5 className="sub-title">CATEGORIES</h5> */}
              <h2 className="m-b20">Our Core Values</h2>
              <p>
                The platform inspires innovation and collaboration by embracing
                the four E’s: Educate, Enable, Empower, and Engage
              </p>
            </div>
            <div className="row">
              {wrapperBlog.map((item, ind) => (
                <div className="col-lg-6 col-md-12 col-sm-12" key={ind}>
                  <div
                    className="icon-bx-wraper box-hover style-2 m-b30"
                    style={{ minHeight: "250px" }}
                  >
                    <div className="icon-lg">
                      <Link to={"/services-details"} className="icon-cell">
                        <i className={item.icon}></i>
                      </Link>
                    </div>
                    <div className="icon-content">
                      <h5 className="dz-tilte m-b10 text-capitalize">
                        {item.title}
                      </h5>
                      <p>{item.content}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="content-inner-2 bg-light section-pattren1">
          <div className="container">
            <div className="row about-bx3 align-items-center">
              <OurMission />
            </div>
          </div>
          <img src={IMAGES.Shape1} className="shape-1 move-1" alt="shape" />
          <img src={IMAGES.Shape2} className="shape-2 move-2" alt="shape" />
          <img src={IMAGES.Shape3} className="shape-3 move-1" alt="shape" />
          <img src={IMAGES.Shape5} className="shape-4 rotating" alt="shape" />
          <img src={IMAGES.Shape6} className="shape-5 rotating" alt="shape" />
          <img src={IMAGES.Shape6} className="shape-6 rotating" alt="shape" />
        </section>
        {/* <section className="content-inner-2">
                    <div className="container">
                        <div className="section-head text-center">
                            <h2 className="title">Akcel News</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                        </div>
                        <NewsSlider />     
                    </div>
                </section> */}
        {/* <div className="call-action style-1 content-inner-1">
                    <div className="container">
                        <UpdateBlog />
                    </div>
                </div> */}
      </div>
    </>
  );
};

export default AboutUs;
